import { Col, Popover, Row, Space } from "antd";
import References from "../../helpers/Reference";
import { useEffect, useState } from "react";
import { FormatMchsIndicatorStates, SetVisibilityGroups } from "./utils";
import { CaretDownFilled, CaretUpFilled, LineChartOutlined } from "@ant-design/icons";

const DROPDOWN_HEIGHT_DELTA = 125

export const MchsDropdown = ({station, mchs, group, height, onClickHandle, onGroupChartClickHandle}) => {

    useEffect(() => {
        setFormatMchs(FormatMchsIndicatorStates(mchs));
    }, []);

    useEffect(() => {
        setVisibleGroups([group])
    }, [group])

    const [visibleGroups, setVisibleGroups] = useState([]);
    const [formatMchs, setFormatMchs] = useState([]);

    const onItemClick = (mch) => {
        onClickHandle(mch);
    }

    const onGroupExpandClick = ( uuid ) => {
        const visible = visibleGroups;
        const index = visible.indexOf(uuid);
        if (index === -1)
            visible.push(uuid);
        else
            visible.splice(index, 1);
        setVisibleGroups([...visible]);
    }

    const onGroupClick = (station, uuid) => {
        onGroupChartClickHandle(station, uuid)        
    }

    return (
        <div className="chart-window-mchs-dropdown">
            <ul style={{maxHeight: `${height - DROPDOWN_HEIGHT_DELTA}px`}}>
                {formatMchs.map((val) => {return (

                    <div key={`mch-dropdown-item-${val.uuid}`}>

                        {val.is_in_group && val.is_first_in_group &&
                            <li onClick={() => onGroupClick(station, val)}>
                                <MchDropdownGroup mch={val} visibleGroups={visibleGroups} onExpandClick={onGroupExpandClick}/>
                            </li>
                        }

                        <li onClick={() => onItemClick(val)} style={{display: SetVisibilityGroups(val, visibleGroups)}}>
                            <MchDropdownItem mch={val}/>
                        </li>
                    </div>
                )})}
            </ul>
        </div>
    );
}

const MchDropdownGroup = ({mch, visibleGroups, onExpandClick}) => {

    const onArrowClick = (e, uuid) => {
        e.preventDefault();
        e.stopPropagation();
        onExpandClick(uuid);
    }

    return (
        <span>
            <Row>
                <Col span={22}>
                    <Space className="pv-1 w-100">
                        <div className="level_code_lamp">
                            <div level_code_text={mch.level_code === null ? References.no_data_code : mch.level_code}>&#9679;</div>
                        </div>
                        <span>{mch.group_name}</span>
                    </Space>
                </Col>
                <Col span={2} className="pv-1 text-right text-lg" onClick={(e) => onArrowClick(e, mch.group_id)}>{visibleGroups.indexOf(mch.group_id) !== -1 ? <CaretUpFilled /> : <CaretDownFilled />}</Col>
            </Row>
        </span>
    )
}

const MchDropdownItem = ({mch}) => {
    return (
        <span>
            <Space className={`pv-1 w-100 ${mch.is_in_group ? "pl-2" : null}`}>
                <div className="level_code_lamp">
                    <div level_code_text={mch.level_code === null ? References.no_data_code : mch.level_code}>&#9679;</div>
                </div>
                {mch.states.length > 0 &&
                <div className="d-flex align-item-center grey" key={`mchs-item`}>
                    [&nbsp;{mch.states.map((state, idx) => {return (
                        <Popover content={state.name} trigger={["hover"]} zIndex={"9999"} key={`mch-indicator-${mch.uuid}-${idx}`}>
                        <div className="level_code_lamp level_code_lamp_sm mh-1">
                            <div level_code_text={state.state === null ? References.no_data_code : state.state}>&#9679;</div>
                        </div>   
                        </Popover>     
                    )})}&nbsp;]
                </div>
                }
                {mch.typeName}
            </Space>
        </span>
    )

}